module.exports = __webpack_public_path__ + "img/bg.da4af3f4.png";